<h2 mat-dialog-title>Preview</h2>
<mat-dialog-content class="mat-typography">
    <div class="px-gutter py-4" fxLayout="column" fxLayoutGap="20px">
        <!-- <p>{{data[0].data.jobTitle}}</p> -->
        <div fxLayout="column">
            <div class="w-full" fxLayout="row" fxlayoutAlign="center center" fxLayoutGap="20px">
                <button mat-mini-fab color="primary" class="my-btn" fxlayoutAlign="center center">
                    <span>1</span>
                </button>
                <div class="w-full flex items-center">
                    <span class="headline">Key</span>
                </div>
            </div>
            <div class="px-10" gdColumns="1fr 1fr" gdColumns.xs="1fr" gdGap="16px">
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>business_center</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Job Title</p>
                        <p class="m-0 body-1">{{data[0]?.data?.jobTitle || '-'}}</p>
                    </div>
                </div>

                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>business_center</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Job Keyword</p>
                        <p class="m-0 body-1">{{data[0]?.data?.jobKeyword || '-'}}</p>
                    </div>
                </div>

                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>business</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Business Unit</p>
                        <p class="m-0 body-1">{{data[0]?.data?.buisnessUnit || '-'}}</p>
                    </div>
                </div>

                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>business</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Departments</p>
                        <p class="m-0 body-1">{{data[0]?.data?.department}}</p>
                    </div>
                </div>

                <div class="py-3" fxLayout="row" fxLayoutAlign="start start" gdColumn="1 / -1">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>business_center</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Job Description</p>
                        <p class="m-0 body-1" [ngClass]="{'limitTextHeight': isReadMoreJobDescription}"
                            [innerHtml]="data[0].data.jobDescription">
                        </p>
                        <ng-container *ngIf="data[0].data.jobDescription !== null">
                            <p *ngIf="data[0].data.jobDescription.length > 100" class="cursor-pointer showMore"
                                (click)="this.isReadMoreJobDescription = !this.isReadMoreJobDescription">
                                {{isReadMoreJobDescription ?
                                'Read More...': 'Read Less'}}
                            </p>
                        </ng-container>
                    </div>
                </div>

                <!-- 
                <div class="py-3" fxLayout="row" fxLayoutAlign="start start">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>business_center</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Required Skill Experience</p>
                        <p class="m-0 body-1" [ngClass]="{'limitTextHeight': isReadMoreRequireSkillExp}"
                            [innerHtml]="data[0].data.requiredSkillExperience"></p>
                        <ng-container *ngIf="data[0].data.requiredSkillExperience !== null">
                            <p *ngIf="data[0].data.requiredSkillExperience.length > 100" class="cursor-pointer showMore"
                                (click)="this.isReadMoreRequireSkillExp = !this.isReadMoreRequireSkillExp">
                                {{isReadMoreRequireSkillExp ?
                                'Read More...': 'Read Less'}}
                            </p>
                        </ng-container>

                    </div>
                </div> -->

                <div class="py-3" fxLayout="row" fxLayoutAlign="start start" gdColumn="1 / -1">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>business</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint"> Job Benefits Per Diem And compensation Packages</p>
                        <p class="m-0 body-1" [ngClass]="{'limitTextHeight': isReadMoreJobBenefits}"
                            [innerHtml]="data[0].data.jobBenefit"></p>
                        <ng-container *ngIf="data[0].data.jobBenefit !== null">
                            <p *ngIf="data[0].data.jobBenefit.length > 100" class="cursor-pointer showMore"
                                (click)="this.isReadMoreJobBenefits = !this.isReadMoreJobBenefits">
                                {{isReadMoreJobBenefits
                                ?
                                'Read More...': 'Read Less'}}
                            </p>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="column" fxlayoutAlign="start start">
            <div fxLayout="row" fxlayoutAlign="center center" fxLayoutGap="20px">
                <button mat-mini-fab color="primary" class="my-btn" fxlayoutAlign="center center">
                    2
                </button>
                <div class="w-full flex items-center"> <span class="headline">Location</span></div>
            </div>
            <div class="px-10" gdColumns="1fr 1fr 1fr" gdColumns.xs="1fr" gdGap="16px">
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>business_center</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">City/Town</p>
                        <p class="m-0 body-1">{{data[1]?.data?.locationCity}}</p>
                    </div>
                </div>

                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>location_on</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Country</p>
                        <p class="m-0 body-1">{{data[1]?.data?.locationCountry}}</p>
                    </div>
                </div>

                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>location_on</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">State</p>
                        <p class="m-0 body-1">{{data[1]?.data?.locationState}}</p>
                    </div>
                </div>

                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>business_center</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Zip/Postal Code</p>
                        <p class="m-0 body-1">{{data[1]?.data?.locationCity}}</p>
                    </div>
                </div>

                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>business_center</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Additional Location</p>
                        <p class="m-0 body-1">{{data[1]?.data?.locationAdditional}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="column" fxlayoutAlign="start start">
            <div fxLayout="row" fxlayoutAlign="center center" fxLayoutGap="20px">
                <button mat-mini-fab color="primary" class="my-btn" fxlayoutAlign="center center">
                    3
                </button>
                <div class="w-full flex items-center"><span class="headline">Salary</span></div>
            </div>
            <div class="px-10" gdColumns="1fr 1fr 1fr" gdColumns.xs="1fr" gdGap="16px">
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>meeting_room</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Min</p>
                        <p class="m-0 body-1">{{data[2]?.data?.salaryMin || '-'}}</p>
                    </div>
                </div>
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>meeting_room</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Max</p>
                        <p class="m-0 body-1">{{data[2]?.data?.salaryMax || '-'}}</p>
                    </div>
                </div>
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>credit_score</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Salary Type</p>
                        <p class="m-0 body-1">{{data[2]?.data?.salType || '-'}}</p>
                    </div>
                </div>
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>money</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Currency</p>
                        <p class="m-0 body-1">{{data[2]?.data?.salCurrency || '-'}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="column" fxlayoutAlign="start start">
            <div fxLayout="row" fxlayoutAlign="center center" fxLayoutGap="20px">
                <button mat-mini-fab color="primary" class="my-btn" fxlayoutAlign="center center">
                    4
                </button>
                <div class="w-full flex items-center"><span class="headline">Optional</span></div>
            </div>
            <div class="px-10" gdColumns="1fr 1fr 1fr" gdColumns.xs="1fr" gdGap="16px">
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>card_travel</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Job Category</p>
                        <p class="m-0 body-1">{{data[3]?.data?.jobCateogary || '-'}}</p>
                    </div>
                </div>
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>card_travel</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Sub Category</p>
                        <p class="m-0 body-1">{{data[3]?.data?.subCategory || '-'}}</p>
                    </div>
                </div>
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>work</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">EEO Job Category</p>
                        <p class="m-0 body-1">{{data[3]?.data?.eeoJobCateogray || '-'}}</p>
                    </div>
                </div>
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>work</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Status</p>
                        <p class="m-0 body-1">{{data[3]?.data?.status || '-'}}</p>
                    </div>
                </div>
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>work</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Job Type</p>
                        <p class="m-0 body-1">{{data[3]?.data?.jobType || '-'}}</p>
                    </div>
                </div>
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>lock_clock</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Hours/Shift</p>
                        <p class="m-0 body-1">{{data[3]?.data?.shift || '-'}}</p>
                    </div>
                </div>
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>lock</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Confidential</p>
                        <p class="m-0 body-1">{{data[3]?.data?.jobConfidential || '-'}}</p>
                    </div>
                </div>
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>language</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Language</p>
                        <p class="m-0 body-1">{{data[3]?.data?.language || '-'}}</p>
                    </div>
                </div>
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>work</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Job Level</p>
                        <p class="m-0 body-1">{{data[3]?.data?.jobLevel || '-'}}</p>
                    </div>
                </div>
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>business_center</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Custom Job ID</p>
                        <p class="m-0 body-1">{{data[3]?.data?.customJobId || '-'}}</p>
                    </div>
                </div>
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>business_center</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Job Priority</p>
                        <p class="m-0 body-1">{{data[3]?.data?.jobPriority || '-'}}</p>
                    </div>
                </div>
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>business_center</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">No of Openings</p>
                        <p class="m-0 body-1">{{data[3]?.data?.noOfOpening || '-'}}</p>
                    </div>
                </div>
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>location_on</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Year of Experience</p>
                        <p class="m-0 body-1">{{data[3]?.data?.yearOfExperience || '-'}}</p>
                    </div>
                </div>
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>maps_home_work</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Level Of Education</p>
                        <p class="m-0 body-1">{{data[3]?.data?.levelOfEducation || '-'}}</p>
                    </div>
                </div>
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>schedule</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Job Duration</p>
                        <p class="m-0 body-1">{{data[3]?.data?.jobDuration || '-'}}</p>
                    </div>
                </div>
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>card_travel</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Travel Frequence</p>
                        <p class="m-0 body-1">{{data[3]?.data?.travelFrequence || '-'}}</p>
                    </div>
                </div>
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>note</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Internal Comment and Notes</p>
                        <p class="m-0 body-1">{{data[3]?.data?.internalCommentNotes || '-'}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="!isSimpleCreationEnabled" fxLayout="column" fxlayoutAlign="start start">
            <div fxLayout="row" fxlayoutAlign="center center" fxLayoutGap="20px">
                <button mat-mini-fab color="primary" class="my-btn" fxlayoutAlign="center center">
                    5
                </button>
                <div class="w-full flex items-center"><span class="headline">Custom Field</span></div>
            </div>
            <div fxLayout="row" class="w-full" fxFlex="100%" fxLayoutAlign="start center" *ngFor="let item of data[4]?.data?.customData;">
                <div fxLayout="row" fxFlex="50%" fxLayoutAlign="start center" *ngIf="item[0]">
                    <p class="pt-2 pb-4 pl-5" fxLayoutAlign="start center">{{item[0].name}}:</p>
                    <p class="pt-2 pb-4 pl-5" fxLayoutAlign="start center">{{item[0].value}}</p>
                </div>
                <div fxLayout="row" fxFlex="50%" fxLayoutAlign="start center" *ngIf="item[1]">
                    <p class="pt-2 pb-4 pl-5" fxLayoutAlign="start center">{{item[1].name}}:</p>
                    <p class="pt-2 pb-4 pl-5" fxLayoutAlign="start center">{{item[1].value}}</p>
                </div>
            </div>
        </div>
        <div *ngIf="!isSimpleCreationEnabled" fxLayout="column" fxlayoutAlign="start start">
            <div fxLayout="row" fxlayoutAlign="center center" fxLayoutGap="20px">
                <button mat-mini-fab color="primary" class="my-btn" fxlayoutAlign="center center">
                    6
                </button>
                <div class="w-full flex items-center"><span class="headline">Users</span></div>
            </div>
            <div class="px-10" gdColumns="1fr 1fr 1fr" gdColumns.xs="1fr" gdGap="16px">
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>group</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Hiring Manager</p>
                        <p class="m-0 body-1">{{data[5]?.data?.hiringManager || '-'}}</p>
                    </div>
                </div>
                <!-- Commented by Cai, 25 Feb 2023 -->
                <!-- <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>groups</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Recruiters</p>
                        <p class="m-0 body-1">{{data[5]?.data?.recruiters || '-'}}</p>
                    </div>
                </div> -->
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>person</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Owner</p>
                        <p class="m-0 body-1">{{data[5]?.data?.owner || '-'}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="!isSimpleCreationEnabled" fxLayout="column" fxlayoutAlign="start start">
            <div fxLayout="row" fxlayoutAlign="center center" fxLayoutGap="20px">
                <button mat-mini-fab color="primary" class="my-btn" fxlayoutAlign="center center">
                    7
                </button>
                <div class="w-full flex items-center"><span class="headline">Questions</span></div>
            </div>
            <div class="px-10" gdGap="16px">
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>meeting_room</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Questions</p>
                        <p class="m-0 body-1" *ngFor="let question of data[6]?.data?.jobQ" >{{question}}</p>
                    </div>
                </div>
                
            </div>
        </div>
        <div *ngIf="!isSimpleCreationEnabled" fxLayout="column" fxlayoutAlign="start start">
            <div fxLayout="row" fxlayoutAlign="center center" fxLayoutGap="20px">
                <button mat-mini-fab color="primary" class="my-btn" fxlayoutAlign="center center">
                    8
                </button>
                <div class="w-full flex items-center"><span class="headline">Resources</span></div>
            </div>
            <div class="px-10" gdGap="16px">
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>meeting_room</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Resources</p>
                        <p class="m-0 body-1">{{data[7]?.data?.resources || '-'}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="!isSimpleCreationEnabled" fxLayout="column" fxlayoutAlign="start start">
            <div fxLayout="row" fxlayoutAlign="center center" fxLayoutGap="20px">
                <button mat-mini-fab color="primary" class="my-btn" fxlayoutAlign="center center">
                    9
                </button>
                <div class="w-full flex items-center"><span class="headline">Scorecard</span></div>
            </div>
            <div class="px-10" gdGap="16px">
                <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
                    <div @scaleIn
                        class="w-10 h-10 rounded-full bg-primary-light text-primary ltr:mr-3 rtl:ml-3 flex items-center justify-center">
                        <mat-icon matPrefix>work</mat-icon>
                    </div>
                    <div @fadeInRight>
                        <p class="m-0 caption text-hint">Available Scorecards</p>
                        <p class="m-0 body-1">{{data[8]?.data?.scorecard || '-'}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button color="primary" mat-button [mat-dialog-close]="true" cdkFocusInitial>OK</button>
</mat-dialog-actions>


<!-- Copyright 2020 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->